import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import adminuser from './modules/adminuser'
import news from './modules/news'
import company from './modules/company'
import permission from './modules/permission'
import bdnote from './modules/bdnote'
import data from './modules/data'
import trade from './modules/trade'
import retail from './modules/retail'
import setting from './modules/setting'
import notes from './modules/notes'
import price from './modules/price'
import trend from './modules/trend'
import cuts from './modules/cuts'
import getters from './getters'
import newdata from './modules/newdata'
import financial from './modules/financial'
import accounting from './modules/accounting'
import contract from './modules/contract'
import report from '@/store/modules/report'
import visual from '@/store/modules/visual'
import advertisement from '@/store/modules/advertisement'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    adminuser,
    news,
    company,
    permission,
    bdnote,
    data,
    trade,
    retail,
    setting,
    notes,
    price,
    trend,
    cuts,
    newdata,
    financial,
    accounting,
    contract,
    report,
    visual,
    advertisement
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js